import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../comp/Footer";
import projects from "../projects/projects"; // Import the projects array
import { BiLogoGithub } from "react-icons/bi";
import Loading from "../comp/Loading";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";



const SingleProject = () => {
  const { id } = useParams(); // Get project ID from the URL
  const [load, setLoad] = useState(true); // Loading state
  const [currentIndex, setCurrentIndex] = useState(0); // State to track current media index
   const navigate = useNavigate();

   //Takes your back to the project section
   const handleBack = () => {
    navigate("/#portfolio"); 
  };
  
  // Find the specific project
  const project = projects.find((item) => item.id === parseInt(id));

  // Merge video, thumbnail, and images into a single array
  const media = [
    ...(project?.video ? [project.video] : []), // Add video if it exists
    // project?.thumbnail, // Add thumbnail
    ...(project?.images || []), // Add additional images
  ];

  useEffect(() => {
    // Simulate loading state
    setTimeout(() => {
      setLoad(false);
    }, 1200);

    // Scroll to top when component renders
    window.scrollTo(0, 0);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? media.length - 1 : prevIndex - 1
    );
  };

  if (load) {
    return <Loading />;
  }

  return (
    <>
      <div className="home">
        <div className="about">
          {/* Back Arrow */}
            <button 
              onClick={handleBack} 
              className="back-button arrowIcon"
              style={{ fontSize: "2.5rem", background: "none", border: "none", cursor: "pointer", marginLeft: "15px" }}
            >
              <BiArrowBack />
            </button>
          <h1>
            {project?.title}
            <a
              href={project?.git}
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: "3rem", marginLeft: "5px" }}
            >
              <BiLogoGithub />
            </a>
          </h1>{" "}
          {/* Project Title */}
          <div className="carousel">
            {/* Render current media */}
            {/* {media[currentIndex]?.includes(".mp4") ? (
              <video
                src={media[currentIndex]}
                controls
                className="carousel-media"
              />
            ) : (
              <img
                src={media[currentIndex]}
                alt={`Slide ${currentIndex}`}
                className="carousel-media"
              />
            )} */}
  {media[currentIndex]?.includes("youtube.com") ? (
  <div className="video-container">
    <iframe
      src={`${media[currentIndex]}?rel=0&modestbranding=1&vq=hd1080`}
      title="Project Video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="carousel-media"
    ></iframe>
  </div>
) : (
  <img
    src={media[currentIndex]}
    alt={`Slide ${currentIndex}`}
    className="carousel-media"
  />
)}
            <div className="carousel-controls">
              <button onClick={handlePrevious} disabled={currentIndex === 0}>
                Previous
              </button>
              <button
                onClick={handleNext}
                disabled={currentIndex === media.length - 1}
              >
                Next
              </button>
            </div>
          </div>
          <div className="projectDetails">

  {/* Description */}
 <div className="projectDescriptionBlock">
  <h3>Description</h3>
  <p className="projectDescription">{project?.description}</p>
</div>

  {/* Technologies + Architecture */}
 <div className="projectGrid">
  {project?.technologies && (
    <div className="projectTech">
      <h3>Technologies</h3>
      <ul>
        {project.technologies.map((tech, index) => (
          <li key={index}>{tech}</li>
        ))}
      </ul>
    </div>
  )}

  {project?.architecture && (
    <div className="projectArch">
      <div className="archFlowVertical">
        <h3>Architecture</h3>
        {project.architecture.map((step, index) => (
          <React.Fragment key={index}>
            <div className="archStep">{step}</div>
            {index !== project.architecture.length - 1 && (
              <div className="archArrow">↓</div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )}
</div>

</div>
          {/* Project Description */}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default SingleProject;
